import React from "react";
import { Trash, Highlighter, Rectangle, PencilSimpleLine, ChatCenteredDots, Stamp } from "@phosphor-icons/react";
import { TYP_LABEL, STAMPS, SCHRIFTSATZ_KATEGORIEN } from "./annotUtils";

const ICON = { highlight: Highlighter, rect: Rectangle, pen: PencilSimpleLine, pin: ChatCenteredDots, stamp: Stamp };

export default function AnnotList({ annots, page, selectedId, onSelect, onDelete }) {
  const pins = annots.filter(a => a.typ === "pin");
  return (
    <aside className="w-[280px] shrink-0 border-l border-[#E5E7EB] bg-[#FAFAFA] flex flex-col min-h-0" data-testid="annot-list">
      <div className="px-3 py-2.5 border-b border-[#E5E7EB] flex items-baseline justify-between">
        <p className="overline text-[#9CA3AF]">Markierungen</p>
        <span className="text-xs text-[#6B7280]">{annots.length}</span>
      </div>
      <div className="flex-1 overflow-auto p-2 space-y-1.5 min-h-0">
        {annots.length === 0 && (
          <p className="text-xs text-[#9CA3AF] p-2 leading-relaxed">Noch keine Markierungen. Wählen Sie oben ein Werkzeug – Textmarker, Rechteck, Stift, Kommentar oder Stempel.</p>
        )}
        {annots.map(a => {
          const Icon = ICON[a.typ] || Highlighter;
          const kat = SCHRIFTSATZ_KATEGORIEN.find(k => k.value === a.schriftsatz_kategorie);
          const pinNr = a.typ === "pin" ? pins.filter(p => p.page === a.page).findIndex(p => p.id === a.id) + 1 : null;
          return (
            <button key={a.id} type="button" onClick={() => onSelect(a)} data-testid={`annot-list-item-${a.id}`}
              className={`w-full text-left bg-white border rounded-md p-2 transition-colors ${selectedId === a.id ? "border-[#1A2238] ring-1 ring-[#1A2238]" : "border-[#E5E7EB] hover:border-[#C9CDD6]"} ${a.page === page ? "" : "opacity-70"}`}>
              <div className="flex items-center gap-2">
                <span className="h-6 w-6 rounded-md flex items-center justify-center text-white shrink-0" style={{ background: a.farbe }}>
                  {pinNr ? <span className="text-[11px] font-bold">{pinNr}</span> : <Icon size={13} weight="fill" />}
                </span>
                <div className="min-w-0 flex-1">
                  <p className="text-[11px] font-medium text-[#0A192F]">
                    {a.typ === "stamp" ? (STAMPS.find(s => s.key === a.stempel)?.label || TYP_LABEL.stamp) : TYP_LABEL[a.typ]}
                    <span className="text-[#9CA3AF] font-mono font-normal"> · S. {a.page}</span>
                  </p>
                  {(a.text || a.notiz) && <p className="text-[11px] text-[#4B5563] line-clamp-2 leading-snug">{a.notiz || a.text}</p>}
                  {kat && <p className="text-[10px] mt-0.5 font-medium" style={{ color: kat.color }}>→ Schriftsatz: {kat.label}</p>}
                </div>
                <span role="button" tabIndex={0} onClick={(e) => { e.stopPropagation(); onDelete(a.id); }} onKeyDown={(e) => { if (e.key === "Enter") { e.stopPropagation(); onDelete(a.id); } }}
                  className="h-6 w-6 rounded flex items-center justify-center text-[#9CA3AF] hover:text-[#D32F2F] hover:bg-[#FEF2F2]" title="Löschen" data-testid={`annot-list-delete-${a.id}`}><Trash size={12} /></span>
              </div>
            </button>
          );
        })}
      </div>
    </aside>
  );
}
